export default __webpack_public_path__ + "aeb92cb327110ab9d2add6b57a60414c.png";